import { render } from "./NavCatHeader.vue?vue&type=template&id=5700f56b&scoped=true"
import script from "./NavCatHeader.vue?vue&type=script&lang=js"
export * from "./NavCatHeader.vue?vue&type=script&lang=js"

import "./NavCatHeader.vue?vue&type=style&index=0&id=5700f56b&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5700f56b"]])

export default __exports__